"use strict";

export function flattenArrayOfObjects(arr, prop) {
  arr = arr.filter(a => a[prop]); // filters out any item that doesn't contain the property
  return arr.reduce((iterator, item) => {
    return iterator.concat(item[prop]);
  }, []);
}
// TODO: clean this up
export function sortObjDsc(arr, property, num_or_str, checkDupProperty) {
  return sortArrAsc(arr, property, num_or_str, checkDupProperty).reverse();
}
// TODO: clean this up
export function sortArrAsc(arr, property, num_or_str, checkDupProperty) {
  if (num_or_str == "str") {
    var sortable = [];

    arr.sort(function(a, b) {
      return parseInt(a[property]) > parseInt(b[property])
        ? 1
        : parseInt(b[property]) > parseInt(a[property])
        ? -1
        : 0;
    });

    return arr;
  } else {
    arr.sort(function(a, b) {
      var aprop = a[property];
      var bprop = b[property];
      return bprop - aprop;
    });
  }
  //arr=arr.removeDuplicatesArrObj(checkDupProperty, false);
  return arr;
}
export function removeDuplicatesArrObjectMultiple(arr, properties) {
  const unique = [];
  const container = [];
  arr
    .map(item => {
      item.combined = properties
        .reduce((acc, prop) => {
          acc.push(item[prop]);
          return acc;
        }, [])
        .join(", ");
      return item;
    })
    .map(item => {
      if (container.indexOf(item.combined) < 0) {
        container.push(item.combined);
        delete item.combined;
        unique.push(item);
      }
    });
  return unique;
}
export function removeDuplicatesArrObj(arr, property, checkmatch = false) {
  var unique = { items: [], finalArr: [], notunique: [] };

  function isUnique() {
    if (checkmatch == true) {
      arr.forEach(function(item) {
        if (
          !unique.items
            .toString()
            .replace(/\W/g, "")
            .match(item[property].replace(/\W/g, ""))
        ) {
          unique.items.push(item[property]);
          unique.finalArr.push(item);
        } else {
          unique.notunique.push(item);
        }
      });
    } else {
      arr.forEach(function(item) {
        const propertySplit = property.split(".") || [property];
        const newProperty = propertySplit.reduce((accum, prop) => {
          accum = item[prop];
          return accum;
        }, {});

        if (unique.items.indexOf(newProperty) < 0) {
          unique.items.push(newProperty);
          unique.finalArr.push(item);
        }
      });
    }
    return unique.finalArr;
  }

  return isUnique(arr);
}

export function getAllIndices(arr, val) {
  let i = 0;
  arr.forEach(item => {
    if (item === val) {
      i++;
    }
  });
  return i;
}

export function sortClosest(arr, compare, baseLatLng = [0, 0]) {
  const mapped = arr.map(item => {
    return {
      item,
      diff: Math.abs(
        item[compare[0]] - baseLatLng[0] - (item[compare[1]] - baseLatLng[1])
      )
    };
  });

  return sortObjDsc(mapped, "diff");
}
